// src/pages/admin/recurringRules/SectionCard.jsx — titled card wrapper used to group
// form sections in RecurringRulesTab
export default function SectionCard({ title, subtitle, children, right }) {
  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">
      <div className="mb-3 flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <div className="text-sm font-semibold text-gray-900">{title}</div>
          {subtitle ? (
            <div className="text-xs text-gray-500">{subtitle}</div>
          ) : null}
        </div>
        {right ? <div>{right}</div> : null}
      </div>
      {children}
    </div>
  );
}
